import { Dispatch, SetStateAction, useEffect, useState } from "react";

export function useStateDebounced<S>(
  initialState: S | (() => S),
  debounce: number,
): [S, Dispatch<SetStateAction<S>>] {
  const [state, setState] = useState(initialState);

  const [debouncedState, setDebouncedState] = useState(state);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedState(state);
    }, debounce);
    return () => clearTimeout(timer);
  }, [state]);

  return [debouncedState, setState];
}
